/** Line markers: "- x" / "* x" read as a bullet, "## x" as plain text. Same as mobile. */
export function normalizeChatLines(text: string): string {
  return text
    .replace(/^(\s*)[-*•]\s+/gm, '$1• ')
    .replace(/^\s*#{1,6}\s+/gm, '');
}
